<script lang="ts">
  import {ImageContent} from '../../../components/';
  import { storyblokEditable, StoryblokComponent } from '@storyblok/svelte';
  import type { ImageContentStoryblokProps } from './image-content.types';

  const { blok }: ImageContentStoryblokProps = $props();

  const image = blok.image ? {
    src: blok.image.filename,
    alt: blok.image.alt || ''
  } : undefined;
</script>

<ImageContent
  use={[[storyblokEditable,blok]]}
  imagePosition={blok.imagePosition}
  {image}
  title={blok.title}
  headingType={blok.headingType}
  description={blok.description}
  overlay={blok.overlay}
  contentAlign={blok.contentAlign}
  colorVariant={blok.colorVariant}
>
  {#each blok.content ?? [] as block}
    <StoryblokComponent blok={block} />
  {/each}
</ImageContent>